// X182 (R80 L9): a Stripe error in plain words, wherever one surfaces. Stripe's Connect
// components pass an error thrown by our fetchClientSecret across their iframe as
// 'JSONSTRING:{"exception":"No such account…"}', and an API error body can arrive as JSON
// text too; the admin sees only the sentence inside, never the wrapper or braces.

const KEYS = ['message', 'exception', 'error', 'detail', 'title'];

function pick(value, depth = 0) {
  if (value == null || depth > 4) return null;
  if (typeof value === 'string') return fromText(value, depth + 1);
  if (Array.isArray(value)) {
    for (const v of value) { const m = pick(v, depth + 1); if (m) return m; }
    return null;
  }
  if (typeof value === 'object') {
    for (const k of KEYS) { const m = pick(value[k], depth + 1); if (m) return m; }
    if (value.errors) {
      const all = Object.values(value.errors).flat();
      for (const v of all) { const m = pick(v, depth + 1); if (m) return m; }
    }
  }
  return null;
}

function fromText(text, depth = 0) {
  let t = String(text).trim();
  if (!t) return null;
  t = t.replace(/^JSONSTRING:\s*/i, '');
  if (/^[[{"]/.test(t)) {
    try { return pick(JSON.parse(t), depth + 1); } catch { /* not JSON: keep the words */ }
  }
  return t;
}

/** The plain message of a Stripe error (an Error, a Stripe.js error object, a load error, a string), else the fallback. */
export function plainStripeError(raw, fallback = 'Stripe could not do that. Please try again') {
  const m = pick(raw?.error ?? raw);
  return m || fallback;
}

/**
 * X238 (TEST_R99 M-2): our API's own refusal of an Account Session ({global: [message], code}),
 * as {message, code}, else null. Stripe's components never pass this through (they report
 * "failed to authenticate"), so the caller keeps it and shows it instead of Stripe's
 * generic load error, with the same fix link Enable payments offers for that code.
 */
export function sessionRefusalFrom(raw) {
  const body = raw?.data ?? raw?.response?._data ?? raw;
  if (!body || typeof body !== 'object') return null;
  const message = Array.isArray(body.global) ? body.global.find((m) => typeof m === 'string' && m.trim()) : null;
  if (!message) return null;
  return {message: message.trim(), code: typeof body.code === 'string' ? body.code : null};
}
